import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {STATUS_API } from 'src/app/constant/config';
import axios from 'src/app/axiosInterceptor';

export const getListVod = createAsyncThunk(
  'vodSlice/getListVod',
  ({ channelId, start_time, end_time }, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        // url: `${process.env.REACT_APP_CDN_API_SERVER}/search/box/${channelId}/start_time=${start_time}&end_time=${end_time}`,
        url: `https://cdn01.vgps.vn/api/search/box/${channelId}?start_time=${start_time}&end_time=${end_time}`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': true,
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          if (!err.response) reject(err);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);
export const vodSlice = createSlice({
  name: 'vodSlice',
  initialState: {
    isLoading: false,
    listVod: [],
    totalVod: 0,
    statusGetAll: null,
    vehicleSelected: null,
    vseekbar: null,
    gpsPayload: null
  },
  reducers: {
    setVehicleSelected: (state, action) => {
      state.vehicleSelected = action.payload;
    },
    setGPSPayload: (state, action) => {
      state.gpsPayload = action.payload;
    }

  },
  extraReducers: {
    [getListVod.pending]: state => {
      state.statusGetAll = STATUS_API.PENDING;
      state.errorGetList = null;
      state.listVod = null;
      state.totalVod = 0;
      state.isLoading = true;
    },
    [getListVod.fulfilled]: (state, action) => {
      state.statusGetAll = STATUS_API.SUCCESS;
      state.listVod = action.payload.data;
      state.totalVod = action.payload.data?.length;
      state.isLoading = false;
    },
    [getListVod.rejected]: (state, action) => {
      state.statusGetAll = STATUS_API.ERROR;
      state.errorGetList = action.payload?.message || action.error;
      state.isLoading = false;
    }
  }
});
export const { setVehicleSelected, setGPSPayload } = vodSlice.actions;
export default vodSlice.reducer;
